export default defineAppConfig({
  ui: {
    colors: {
      primary: 'indigo',
      secondary: 'blue',
      neutral: 'gray',
      success: 'green',
      info: 'blue',
      warning: 'yellow',
      error: 'red',
      dark: 'midnight',
    },

    accordion: {
      slots: {
        header:
          'px-4 data-[state=open]:bg-primary-50 dark:data-[state=open]:bg-primary-900/20',
        trigger: 'subtitle-2',
      },
    },

    badge: {
      defaultVariants: {
        color: 'neutral',
        variant: 'subtle',
      },
    },

    button: {
      slots: {
        base: 'flex disabled:cursor-not-allowed text-default',
        leadingIcon: 'shrink-0',
      },
      variants: {
        size: {
          sm: {
            base: '!text-button-sm px-2.5 py-1.5',
            leadingIcon: 'h-3 w-3',
            trailingIcon: 'h-3 w-3',
          },
          md: {
            base: '!text-button px-3 py-2',
            leadingIcon: 'h-3.5 w-3.5',
            trailingIcon: 'h-3.5 w-3.5',
          },
          lg: {
            base: '!text-lg px-4 py-3',
            leadingIcon: 'h-5 w-5',
            trailingIcon: 'h-5 w-5',
          },
        },
        variant: {
          link: '!text-secondary-600 !hover:text-secondary-800 hover:underline',
        },
      },
      defaultVariants: {
        color: 'neutral',
        size: 'sm',
        variant: 'solid',
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class: 'bg-primary-600 hover:bg-primary-800 text-white',
        },
        {
          color: 'primary',
          variant: 'outline',
          class:
            'text-primary-600 ring-primary-600 hover:bg-primary-50 hover:ring-primary-800 hover:text-primary-800',
        },
        {
          color: 'success',
          variant: 'solid',
          class: 'bg-success-600 hover:bg-success-800',
        },
        {
          color: 'success',
          variant: 'outline',
          class:
            'text-success-600 ring-success-600 hover:bg-success-50 hover:ring-success-800 hover:text-success-800',
        },
        {
          color: 'warning',
          variant: 'solid',
          class: 'bg-warning-500 hover:bg-warning-700',
        },
        {
          color: 'warning',
          variant: 'outline',
          class:
            'text-warning-500 ring-warning-500 hover:bg-warning-50 hover:ring-warning-700 hover:text-warning-700',
        },
        {
          color: 'error',
          variant: 'solid',
          class: 'bg-error-600 hover:bg-error-800',
        },
        {
          color: 'error',
          variant: 'outline',
          class:
            'text-error-600 ring-error-600 hover:bg-error-50 hover:ring-error-800 hover:text-error-800',
        },
        {
          color: 'info',
          variant: 'solid',
          class: 'bg-info-600 hover:bg-info-800',
        },
        {
          color: 'info',
          variant: 'outline',
          class:
            'text-info-600 ring-info-600 hover:bg-info-50 hover:ring-info-800 hover:text-info-800',
        },
        {
          color: 'neutral',
          variant: 'solid',
          class: 'bg-neutral-600 hover:bg-neutral-800',
        },
        {
          color: 'neutral',
          variant: 'outline',
          class:
            'text-neutral-600 ring-neutral-600 hover:bg-neutral-50 hover:ring-neutral-800 hover:text-neutral-800',
        },
        {
          variant: 'link',
          color: 'secondary',
          class: 'text-link',
        },
        {
          variant: 'link',
          class: 'text-link-sm',
        },
      ],
    },

    checkbox: {
      slots: {
        base: 'dark:bg-accented dark:ring-default inset-shadow-xs',
      },
    },
    header: {
      slots: {
        root: 'bg-muted/75',
        title: 'text-base lg:text-lg font-semibold',
      },
    },
    input: {
      slots: {
        base: 'dark:bg-accented dark:ring-default inset-shadow-xs',
      },
    },
    inputMenu: {
      slots: {
        base: 'w-full dark:bg-accented dark:ring-default inset-shadow-xs',
        tagsInput: 'w-full',
        content: 'dark:bg-elevated',
      },
    },
    prose: {
      h3: {
        slots: {
          base: 'text-xs leading-4.5 font-medium tracking-[0.1px]',
        },
      },
      p: {
        base: 'leading-5 my-0',
      },
      ul: {
        base: 'my-0',
      },
      li: {
        base: 'my-0',
      },
    },

    radioGroup: {
      slots: {
        base: 'dark:bg-accented dark:ring-default inset-shadow-xs',
      },
    },

    select: {
      slots: {
        base: 'border border-default',
        placeholder: 'text-muted',
      },
    },

    switch: {
      slots: {
        base: 'data-[state=unchecked]:bg-accented inset-shadow-xs',
        thumb: 'border border-default',
      },
    },

    tabs: {
      compoundVariants: [
        {
          orientation: 'horizontal',
          variant: 'link',
          class: {
            list: 'border-b -mb-px',
            indicator: 'bottom-0 h-[2px]',
          },
        },
      ],
    },

    textarea: {
      slots: {
        base: 'dark:bg-accented dark:ring-default',
      },
    },
  },
})
